import axiosInstance from "./api_helper";

const customerReturnService = {
  list: ({ clientId, dateFrom, dateTo, commercialId, query }) => {
    const params = {};
    if (clientId !== undefined && clientId !== null) params.clientId = clientId;
    if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (query) params.query = query;

    return axiosInstance.get(`/api/retours-client`, { params });
  },

  resume: (params) => {
    return axiosInstance.get(`/api/retours-client/resume`, { params });
  },

  search: (params) => {
    return axiosInstance.get(`/api/retours-client/search`, { params });
  },
  generateNumero: () => {
    return axiosInstance.get(`/api/retours-client/generate-number`);
  },
  getById: (id) => {
    return axiosInstance.get(`/api/retours-client/${id}`);
  },

  create: (data) => {
    return axiosInstance.post(`/api/retours-client`, data);
  },

  update: (id, data) => {
    return axiosInstance.put(`/api/retours-client/${id}`, data);
  },

  validate: (id) => {
    return axiosInstance.post(`/api/retours-client/${id}/validate`);
  },

  reset: (id) => {
    return axiosInstance.put(`/api/retours-client/${id}/reset`);
  },

  cancel: (id) => {
    return axiosInstance.post(`/api/retours-client/${id}/cancel`);
  },

  delete: (id) => {
    return axiosInstance.delete(`/api/retours-client/${id}`);
  },

  generatePdf: (id) => {
    return axiosInstance.get(`/api/retours-client/${id}/pdf`, {
      responseType: 'blob'
    });
  }
};

export default customerReturnService;
